import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu/index.js';
import LocalizationMenu from './LocalizationMenu.js';
import Search from '../Search/index.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      Search,
      LocalizationMenu,
    },
  };

  /**
   * Mounted
   */
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const subId = params.get('kwks2s');
    if (subId) localStorage.setItem('kwanko_subid', subId);
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 128;

    toggleClass(document.body, 'is-on-top', isOnTop);
    toggleClass(document.body, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.body, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.body, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   *
   */
  onMenuOpen() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.body, 'is-menu-open', openedMenus.length > 0);
  }

  /**
   *
   */
  onMenuClose() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.body, 'is-menu-open', openedMenus.length > 0);
  }

  /**
   *
   */
  onSearchOpen() {
    this.$children.Menu[0].closeMenu();
  }
}
